import LogRocket from 'logrocket'

let alreadyInitialized: boolean = false;
let identifiedUid: string | null = null;
let storeInstance: any;

function getStore() {
  if (!storeInstance) {
    const module = require("@/store");
    storeInstance = module?.default ?? module;
  }
  return storeInstance;
}

export function initialize() {
  if (!getLogRocketAllowed()) {
    return;
  }
  if (alreadyInitialized) {
    return;
  }
  LogRocket.init('3gwxd3/processing')
  alreadyInitialized = true;
}

export function identify(user: any) {
  if (!getLogRocketAllowed()) {
    return;
  }
  if (user?.uid && user.uid === identifiedUid) {
    return;
  }
  if (user?.uid) {
    identifiedUid = user.uid
  }
  LogRocket.identify(user.uid, {
    name: user.displayName,
    email: user.email,
    subscriptionType: 'pro'
  });
}

export function reset() {
  if (!getLogRocketAllowed()) {
    return;
  }
  LogRocket.startNewSession()
}

function getUid() {
  const store = getStore();
  return (store.state as any).user?.user?.uid
}

function getLocationGuid() {
  const store = getStore();
  return (store.state as any).user?.location?.guid
}

function getStationGuid() {
  const store = getStore();
  return store.getters["getField"]("processingStation")?.guid;
}

function getLogRocketAllowed() {
  const store = getStore();
  return (store.state as any).user?.logRocketAllowed
}

export function connectedToProxy(stationGuid: string, previousStationGuid?: string) {
  if (stationGuid !== previousStationGuid) {
    logRocketPermission()
  }
}

export function checkLogRocketPermission() {
  logRocketPermission()
    .then((allowed) => {
      const store = getStore();
      const wasAllowed = getLogRocketAllowed()
      //console.log("checkLogRocketPersmission", allowed)
      store.commit("user/logRocketAllowed", allowed);
      if (!wasAllowed && allowed) {
        initialize()
        identify((store.state as any).user.user)
        reset()
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

async function logRocketPermission() {
  const store = getStore();

  const uid = getUid()
  const locationGuid = getLocationGuid()
  const stationGuid = getStationGuid()

  if (!uid || !locationGuid || !stationGuid) {
    return false
  }

  const gql = `query logRocketPermission($uid: String!, $locationGuid: String!, $stationGuid: String!) {
    logRocketPermission(uid: $uid, locationGuid: $locationGuid, stationGuid: $stationGuid)
  }`
  let json = await store.dispatch("graphQl", { gql, variables: { uid: getUid(), locationGuid: getLocationGuid(), stationGuid: getStationGuid() }, destination: "cloud" }, { root: true })
  console.log("checkLogRocketPersmission", json)
  return json?.data?.logRocketPermission
}
